'use client';

import {
  LDProvider,
  reactSdkContextFactory,
} from 'launchdarkly-react-client-sdk';
import { type PropsWithChildren } from 'react';

import { useEnvironment } from './useEnvironment';
import { useUser } from './useUser';

export const flagsContext = reactSdkContextFactory();

export const LaunchDarklyProvider = (
  props: PropsWithChildren<{ clientId: string | undefined }>
) => {
  const { isDev, isDemo } = useEnvironment();
  const { currentProjectId, user } = useUser();
  if (!currentProjectId) {
    return props.children;
  }

  if (isDemo || isDev) {
    return (
      <flagsContext.Provider
        value={{
          flags: {
            // Amir
            NonCognitoEonAccounts: false,
            SkipOnboarding: false,
            fullDirRestore: true,
            FileExplorerPerSnapshot: false,
            dlsgFrontend: true,

            // Erez
            enableHourlyBackup: false, // opened only for Fanatics
            pitrEnabled: true,
            ownCustomerOnboardingEnabled: false,
            byovEnabled: false,
            hourlyDlsgPolicyEnabled: false,

            // abir
            isSplunkNotificationTargetEnabled: true,
            isAuditLogNotificationTypeEnabled: true,

            // waiting for prod/ux
            orgWithoutStackSet: false,

            // Ran
            terraformAzureOnboarding: true,

            // Tzachi - Consolidate onboarding experience
            consolidateOnboardingExperienceEnabled: false,
          },
          flagKeyMap: {},
          ldClient: undefined,
        }}
      >
        {props.children}
      </flagsContext.Provider>
    );
  }

  if (!props.clientId || !user) {
    return props.children;
  }

  return (
    <LDProvider
      reactOptions={{
        reactContext: flagsContext,
        useCamelCaseFlagKeys: false,
      }}
      clientSideID={props.clientId}
      context={{
        kind: 'multi',
        user: {
          key: currentProjectId, // backward compatibility
          name: user.givenName,
          email: user.email,
          id: user.id,
        },
        organization: {
          key: user.eonAccount.id,
          name: user.eonAccount.name,
          domain: user.eonAccount.domain,
          projectId: currentProjectId,
        },
      }}
      options={
        {
          /* ... */
        }
      }
    >
      {props.children}
    </LDProvider>
  );
};
